
(function ($) {
  $('.pagination-button').on('click', function () {
    let current = $(this);
    let text = current.text();
    let query = current.data('query');
    let paged = current.data('paged');
    let pages = current.data('pages');
    let target = current.data('target');
    let focus = $(target).children().last();

    $.ajax({
      url: '/wp-admin/admin-ajax.php',
      type: 'POST',
      data: {
        action: 'load_more_posts',
        fn: 'load_more_posts',
        query,
        paged
      },
      beforeSend: function () {
        current.text('Loading').attr('disabled', true);
      },
      success: function (result) {
        $(target).append(result);
        if (paged == pages) {
          current.remove();
        } else {
          current.text(text).attr('disabled', false).data('paged', parseInt(paged) + 1);
        }
        focus.next().focus();
      }, error: function (error) {
        console.error(error);
      }
    })
  });
})(jQuery);
